

var _logger = require('xo-beaver/dist/logger');

var _checkout = require('xo-models/src/checkout');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BalanceEligibilityFactory', ['$rootScope', '$q', function ($rootScope, $q) {
    var state = {
        eligibility: null
    };
    var get = function get() {
        _logger.$logger.info('$BalanceEligibilityFactory_get');
        return state;
    };
    /**
     * @param {Object} options
     * @param {Object} options.checkoutSession $CheckoutSessionModel
     * @returns {Promise<Object>} Returns the current $BalanceEligibilityFactory state
     */
    var init = function init() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$checkoutSession = _ref.checkoutSession,
            checkoutSession = _ref$checkoutSession === undefined ? _checkout.$CheckoutSessionModel.instance($rootScope.token) : _ref$checkoutSession;

        var disallowedInstruments = checkoutSession.get('fundingOptions.disallowedInstruments', []);
        var hasBalanceInstrument = disallowedInstruments.length && disallowedInstruments.find(function (fi) {
            return fi.declineReason === 'CIP_INCOMPLETE' && fi.type === 'BALANCE';
        });
        if (hasBalanceInstrument) {
            var currentState = get();
            currentState.eligibility = false;
        }
        _logger.$logger.info('$BalanceEligibilityFactory_init', get());
        return $q.resolve(get());
    };
    // Expose public $BalanceEligibilityFactory APIs
    return {
        get: get,
        init: init
    };
}]);

_logger.$logger;

_checkout.$CheckoutSessionModel;


//////////////////
// WEBPACK FOOTER
// ./pages/services/balance/index.js
// module id = ./pages/services/balance/index.js
// module chunks = 0